var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmlCheckIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.666992L13.478 1.88433C13.7827 1.95233 14 2.22233 14 2.53499V9.19299C14 10.5303 13.3313 11.7797 12.2187 12.521L8 15.3337L3.78133 12.521C2.668 11.779 2 10.5303 2 9.19366V2.53499C2 2.22233 2.21733 1.95233 2.522 1.88433L8 0.666992ZM8 2.03299L3.33333 3.06966V9.19299C3.33333 10.0843 3.77867 10.917 4.52067 11.4117L8 13.7317L11.4793 11.4117C12.2213 10.917 12.6667 10.085 12.6667 9.19366V3.06966L8 2.03366V2.03299ZM10.968 5.48166L11.9113 6.42433L7.66867 10.667L4.84 7.83833L5.78267 6.89566L7.668 8.78099L10.968 5.48099V5.48166Z",
    fill: "#85858E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmlCheckIc);
export default __webpack_public_path__ + "static/media/aml-check-ic.87ac250bf74830b7409213e50d37bed2.svg";
export { ForwardRef as ReactComponent };